/**
 * SaveConflictModal — aviso de escritura concurrente (E1 · SAVE_CONFLICT_GUARD).
 *
 * Aparece cuando el servidor rechazó un guardado porque el proyecto cambió
 * desde otro lugar (otra pestaña, otro navegador o el agente por MCP) y acá
 * hay cambios locales sin guardar. Sin cambios locales la recarga es
 * silenciosa y este modal no se muestra.
 */
import { AlertTriangle, Download, Loader2, Upload } from 'lucide-react';
import { useState } from 'react';
import { useWorkflowStore } from '../../store/workflowStore';

export default function SaveConflictModal() {
  const conflict = useWorkflowStore((s) => s.saveConflict);
  const resolveWithReload = useWorkflowStore((s) => s.resolveConflictReload);
  const resolveWithForce = useWorkflowStore((s) => s.resolveConflictForce);
  const [busy, setBusy] = useState(null);

  if (!conflict) return null;

  const run = async (which, fn) => {
    setBusy(which);
    try { await fn(); } finally { setBusy(null); }
  };

  return (
    <div className="save-conflict-overlay" data-testid="save-conflict-modal">
      <div className="save-conflict-card">
        <div className="save-conflict-head">
          <AlertTriangle size={18} />
          <h3>Este proyecto cambió desde otro lugar</h3>
        </div>
        <p>
          Alguien (otra pestaña, otro navegador o el agente por MCP) guardó una
          versión más nueva de <strong>{conflict.projectName}</strong>. Tenés
          cambios locales sin guardar.
        </p>
        <div className="save-conflict-actions">
          <button
            className="save-conflict-btn primary"
            onClick={() => run('reload', resolveWithReload)}
            disabled={!!busy}
            data-testid="save-conflict-reload"
          >
            {busy === 'reload' ? <Loader2 size={13} className="spin" /> : <Download size={13} />}
            Recargar
          </button>
          <button
            className="save-conflict-btn"
            onClick={() => run('force', resolveWithForce)}
            disabled={!!busy}
            data-testid="save-conflict-force"
          >
            {busy === 'force' ? <Loader2 size={13} className="spin" /> : <Upload size={13} />}
            Guardar mi versión igual
          </button>
        </div>
        <span className="save-conflict-hint">
          Recargar descarta tus cambios locales. Guardar tu versión sobrescribe
          la del servidor (versión {conflict.serverVersion ?? '—'}).
        </span>
      </div>
    </div>
  );
}
